import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// interfaces
import { ICompany } from 'src/app/core/interfaces/ads/companies';

// services
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

export const companiesResolver: ResolveFn<Observable<ICompany[]>> = (route, state) => {
  
  /**
   * 
   */
  const _api = inject(ApiResponseService);

  /**
   * 
   */
  return _api.Companies();

};
